import ScorecardIcon from '@atlaskit/icon/core/scorecard';
import * as React from 'react';

export function SvgCheckCircle() {
  return <ScorecardIcon label="" testId="ads-refreshed-icon" />;
}
